// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tcCPmYl1SB096E9vF_kH{margin-top:3px;margin-left:2px}`, "",{"version":3,"sources":["webpack://./src/pages/chatbot/ui/ChatbotEdit/StepQualify/ui/PointQualifyInstructions/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,cAAA,CACA,eAAA","sourcesContent":[".error {\n  margin-top: 3px;\n  margin-left: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"error": `tcCPmYl1SB096E9vF_kH`
};
export default ___CSS_LOADER_EXPORT___;
